import React, { Component } from 'react';
import DashboardCard from '$components/ProductDashboard/DashboardCard';
import DashboardHeader from '$components/ProductDashboard/DashboardHeader';
import UpcomingWorkloadChart from './UpcomingWorkloadChart';

class UpcomingWorkload extends Component {
  renderChart() {
    const { product } = this.props;
    const { numMemoryEstimates } = product;

    const chartDisabled = numMemoryEstimates === 0;
    if (chartDisabled) {
      return (
        <div data-aaa="upcomingWorkloadDisabled" style={{ textAlign: 'center' }}>
          Complete textbook chapters to enable this chart.
        </div>
      );
    }

    return <UpcomingWorkloadChart product={product} />;
  }

  render() {
    return (
      <div>
        <DashboardHeader header="Upcoming workload" />
        <DashboardCard>{this.renderChart()}</DashboardCard>
      </div>
    );
  }
}

export default UpcomingWorkload;
